import type { TareAppModel } from '../native-modules/types/TareBridge';

export interface Locale {
    language: string;
    country: string | null;
}

export const DEFAULT_LOCALE: Locale = { language: 'en', country: null };

/**
 * Deserialize the locale from the TareAppModel
 */
export function deserializeTareLocale(
    locale: TareAppModel['locale'] | null | undefined,
    fallback: Locale = DEFAULT_LOCALE,
): Locale {
    if (!locale) {
        return fallback;
    }

    return {
        language: locale.languageCode,
        country: locale.countryCode || null,
    };
}

export const getCountryFromLocaleString = (locale: string | undefined): string | undefined => {
    const localeParts = locale?.trim().replace(/_/g, '-').split('-') ?? [];
    const country = localeParts.slice(1).find((part) => /^[a-z]{2}$/i.test(part));

    return country?.toUpperCase();
};

export const serializeLocaleToBCP47 = ({ language, country }: Locale): string =>
    !language ? DEFAULT_LOCALE.language : country ? `${language}-${country}` : language;
